/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Rights_Toast_Subject_FailedInputs */



/**
* | output |
* | --- |
* | "Failed to add {count} overrides." |
*
* @param {Rights_Toast_Subject_FailedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const rights_toast_subject_failed = /** @type {((inputs: Rights_Toast_Subject_FailedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rights_Toast_Subject_FailedInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.count} Ausnahmen konnten nicht hinzugefügt werden.`)
	return /** @type {LocalizedString} */ (`Failed to add ${i?.count} overrides.`)
});